<style scoped lang="scss">
.clickable {
  cursor: pointer;
}
.clickable:hover {
  text-decoration: underline;
}
@media (min-width: 1200px) {
  .right-border {
    border-right: solid 1px;
  }
}
.active-article {
  font-weight: 550;
  font-style: italic;
}
textarea {
  min-height: 30rem;
}
</style>

<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>FAQ Artikel</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-3 right-border">
            <ul class="list-group pl-3 list-unstyled">
              <li
                class="pt-3 text-md clickable"
                :class="{
                  'active-article': currentArticle.id == newArticle.id
                }"
                @click="setArticle('newArticle')"
              >
                <span>neuer Artikel</span>
              </li>

              <li
                v-for="(article, key) in articles"
                v-if="article != newArticle"
                :key="key"
                class="pt-3 text-md clickable"
                :class="{ 'active-article': currentArticle.id == article.id }"
                @click="setArticle(key)"
              >
                <span v-html="article.slug"></span>
              </li>
            </ul>
          </div>
          <div class="col-9">
            <div class="form-group row">
              <col-label>Link</col-label>
              <div class="col-8">
                <input class="form-control" v-model="currentArticle.slug" />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Titel</col-label>
              <div class="col-8">
                <input class="form-control" v-model="currentArticle.title" />
              </div>
            </div>
            <div class="form-group row">
              <col-label>Artikel</col-label>
              <div class="col-8">
                <textarea
                  class="form-control"
                  v-model="currentArticle.article"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <col-label>Reihenfolge</col-label>
              <div class="col-8">
                <input
                  min="0"
                  type="number"
                  class="form-control"
                  v-model="currentArticle.order"
                />
              </div>
            </div>
            <v-button
              v-if="currentArticle.id != newArticle.id"
              @click.native="remove()"
              class="btn btn-danger float-left"
              >löschen</v-button
            >
            <v-button
              @click.native="persist()"
              class="btn btn-primary float-right"
              >speichern</v-button
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import swal from "sweetalert2";
export default {
  created() {
    this.$store.dispatch("faq/read");
    this.currentArticle = this.newArticle;
  },
  computed: {
    articles() {
      return {
        newArticle: { ...this.newArticle },
        ...this.$store.getters["faq/faqs"]
      };
    }
  },
  methods: {
    setArticle(key) {
      this.currentArticle = { ...this.articles[key] };
    },
    remove() {
      swal
        .fire({
          title: `Den Artikel "${this.currentArticle.title}" löschen?`,
          html: `Soll der Artikel "${this.currentArticle.title}" wirklich gelöscht werden? Gelöschte Artikel können nicht wiederhergestellt werden. <br><br> Um den Artikel zu löschen gebe "${this.currentArticle.slug}" ein.`,
          showCancelButton: true,
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#d33",
          confirmButtonText: "Diesen Artikel löschen!",
          cancelButtonText: "Nein Danke",
          input: "text",
          inputAttributes: {
            autocapitalize: "off",
            placeholder: `${this.currentArticle.slug}`
          }
        })
        .then(result => {
          if (result.value && result.value == this.currentArticle.slug) {
            this.$store.commit("faq/delete", this.currentArticle.id);
            this.$store
              .dispatch("faq/delete", {
                url: `/api/v1/faq/${this.currentArticle.id}/`
              })
              .then(() => {
                this.currentArticle = this.newArticle;
                this.$store.dispatch("faq/read");
              });
            this.$notify({
              title: "Der Artikel wurde erfolgreich gelöscht",
              type: "success"
            });
          } else {
            this.$notify({
              title: "Der Artikel wurde nicht gelöscht",
              type: "error"
            });
          }
        });
    },
    persist() {
      let action = "update";
      let url = `/api/v1/faq/${this.currentArticle.id}/`;
      if (this.currentArticle.id == 0) {
        action = "create";
        url = `/api/v1/faq/`;
      }
      this.$store
        .dispatch(`faq/${action}`, {
          url: url,
          data: {
            slug: this.currentArticle.slug,
            title: this.currentArticle.title,
            article: this.currentArticle.article,
            order: this.currentArticle.order
          }
        })
        .then(response => {
          this.currentArticle = response.data;
          this.$store.dispatch("faq/read");
          this.$notify({
            title: "Der Artikel wurde erfolgreich gespeichert",
            type: "success"
          });
        })
        .catch(error => {
          let errors = "";
          const errorKeys = Object.keys(error.response.data.errors);
          errorKeys.forEach(errorKey => {
            errors += error.response.data.errors[errorKey].join(" ") + "<br>";
          });
          this.$notify({
            title: error.response.data.message,
            text: errors,
            type: "error"
          });
        });
    }
  },
  data() {
    return {
      newArticle: {
        id: 0,
        keyword: "",
        article: "",
        order: 0
      },
      currentArticle: {}
    };
  }
};
</script>
